$(function () {
  $("a[rel~=gallery],a[data-rel~=gallery]").click(function (e) {
    e.preventDefault()
  }).fancybox();
  $("a[rel~=video],a[data-rel~=video]").click(function(e) {
    e.preventDefault()
    $.fancybox({'padding':0,'autoScale':false,'transitionIn':'none','transitionOut':'none','title':this.title,'width':640,'height':385,'href':this.href,'type':'iframe'});
  });
})
